import { Status } from 'helpers/StatusHelper';
import { useTranslation } from 'react-i18next';

const JobStatus = job => {
  const { t } = useTranslation();

  const status_key = (job.status || '').toUpperCase();
  const status = Status[status_key];

  return (
    <div className="lh-sm">
      <small>Status</small> <br />
      <b className={`text-uppercase ${status.colorClassName}`}>{t(status.tkey)}</b>
    </div>
  );
};

export default JobStatus;
